export const formatPersonName = (person, fallback = '') => {
  if (!person) return fallback;

  const fullName = [
    person.last_name,
    person.first_name,
    person.middle_name
  ].filter(Boolean).join(' ').trim();

  return fullName || person.login || fallback;
};

export const getPersonInitials = (person, fallback = 'U') => {
  if (!person) return fallback;

  const lastInitial = person.last_name?.[0]?.toUpperCase() || '';
  const firstInitial = person.first_name?.[0]?.toUpperCase() || '';
  const initials = `${lastInitial}${firstInitial}`.trim();

  return initials || person.login?.[0]?.toUpperCase() || fallback;
};
